import React from 'react';
import { SweepstakesUnifiedDrawer } from '../components/SweepstakesDrawer/SweepstakesUnifiedDrawer';

export const SweepstakesDrawerContainer = () => {
  return (
    <div data-testid="sweepstakes-drawer-container">
      <SweepstakesUnifiedDrawer />
    </div>
  );
};